export const OfferUnsubscribeSuccessViewMessages = {
  successMessage: {
    id: 'Pages.OfferUnsubscribeSuccess.View.successMessage',
    description: 'Offer Unsubscribe Success Message',
  },
}
